import { useEffect, useRef, useState } from 'react';
import { toPng } from 'html-to-image';
import { logError } from '../lib/logger';

export const useShareCardGenerator = (story) => {
  const cardRef = useRef(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [blob, setBlob] = useState(null);
  const [generating, setGenerating] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    // Poll for the off-screen card ref instead of a fixed delay (avoids StrictMode race)
    const waitForCard = async () => {
      for (let i = 0; i < 20; i++) {
        if (cardRef.current) return true;
        if (cancelled) return false;
        await new Promise((r) => setTimeout(r, 30));
      }
      return !!cardRef.current;
    };
    const generate = async () => {
      setGenerating(true);
      setError('');
      const ready = await waitForCard();
      if (cancelled) return;
      if (!ready) {
        setError('Could not generate the share card. Please try again.');
        setGenerating(false);
        return;
      }
      try {
        const dataUrl = await toPng(cardRef.current, {
          cacheBust: true,
          pixelRatio: 1,
          width: 1200,
          height: 630,
          skipFonts: true,
          backgroundColor: '#0B1220',
        });
        if (cancelled) return;
        setPreviewUrl(dataUrl);
        const res = await fetch(dataUrl);
        const b = await res.blob();
        if (!cancelled) setBlob(b);
      } catch (e) {
        logError('useShareCardGenerator:generate', e);
        if (!cancelled) setError('Could not generate the share card. Please try again.');
      } finally {
        if (!cancelled) setGenerating(false);
      }
    };
    generate();
    return () => { cancelled = true; };
  }, [story.id]);

  return { cardRef, previewUrl, blob, generating, error };
};
